export function logError(error, context = '') {
    const message = error?.message || error || 'Unknown error';
    const stack = error?.stack || '';
    console.error(`[Kino Error]${context ? ` [${context}]` : ''}: ${message}`, stack);
}

export function notifyUser(message = 'An error occurred. Please try again.') {
    if (typeof Video !== 'undefined' && Video.showNotification) {
        Video.showNotification(
            '<i class="fas fa-exclamation-triangle"></i>',
            message,
            'error'
        );
    }
}
